import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { IconButton as CustomizedButton } from "../InputComponents/IconButton";
import { CheckBoxIcon, CheckboxBorder, CloseIcon, CopyIcon, DownloadIcon } from "../Icons/Icons";
import { TextInput } from "../InputComponents/TextInput";
import { Checkbox, Grid, IconButton, Typography,Box, Tooltip } from "@mui/material";
import {
  SubmitButton,
  DialogTitleStyle,
  helperText,
  DialogBackground,
  ViewMapButton,
} from "../Theme/Theme";
import { SwitchButton } from "../InputComponents/SwitchButton";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CustomDivider } from "../InputComponents/CustomDivider";
import { useState } from "react";

export default function AlertForm(props) {

  const isValidCoordinates = (coords) => {
    if (!coords) return false;
    const [latStr, lonStr] = coords.split(",").map(s => s.trim());
    if (!latStr || !lonStr) return false;

    const lat = parseFloat(latStr);
    const lon = parseFloat(lonStr);

    return (
      !isNaN(lat) && lat >= -90 && lat <= 90 &&
      !isNaN(lon) && lon >= -180 && lon <= 180
    );
  };

  function onCopyClinicCode() {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(props.clinicCode);
    } else {
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = props.clinicCode;
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      document.execCommand('copy');
      document.body.removeChild(tempTextArea);
    }
  }

  function renderDialogContent() {
    if (props.isQrGenerated) {
      return (
        <>
          <DialogContent>
            <Typography style={{
              fontWeight: "500",
              fontSize: "16px",
              paddingBottom: "3px"
            }}>
              QR Code
            </Typography>
            <Typography style={{ fontWeight: "500", fontSize: "12px", color: "#8193A6" }}>
              Scan this QR code to quickly access your account or share it with others for easy authentication.
            </Typography>
            <Grid
              container
              style={{
                borderRadius: "5px",
                backgroundColor: "#F9FAFB",
                padding: "16px",
                alignItems: 'center',
                marginTop: "10px",
                marginBottom: "10px",
                flexDirection: 'column',
                display: 'flex'
              }}>
              <img alt="QR code" src={props.qrCode} width={200} height={200} />
              <Button
                onClick={() => props.onClickDownloadQR()}
                startIcon={<DownloadIcon />}
                style={{
                  width: '25%',
                  marginTop: "10px",
                  backgroundColor: "#FFFFFF",
                  color: "#8193A6",
                  border: "2px solid #F1F2F4",
                  borderRadius: "6px",
                  fontSize: "12px",
                  textTransform: "none"
                }}>
                Download
              </Button>
            </Grid>
            <Typography style={{ fontWeight: "500", fontSize: "16px", paddingBottom: "3px" }}>Passcode</Typography>
            <Typography style={{ fontWeight: "500", fontSize: "12px", color: "#8193A6" }}>
              Your secure 4-digit passcode for additional authentication. Keep this confidential and secure.
            </Typography>
            <Grid
              container
              style={{
                borderRadius: "5px",
                backgroundColor: "#F9FAFB",
                padding: "16px",
                alignItems: 'center',
                marginTop: "10px",
                marginBottom: "10px",
                flexDirection: 'column',
                display: 'flex'
              }}>
              <Grid container style={{ flexDirection: "row", justifyContent: 'center' }} columnGap={1}>
                {props.clinicCode.split("").map((code, index) => {
                  return (
                    <Grid
                      key={index}
                      style={{
                        padding: "12px 24px 12px 24px",
                        backgroundColor: "#FFFFFF",
                        border: "2px solid #F1F2F4",
                        borderRadius: "6px",
                      }}>
                      <Typography style={{ fontWeight: "500", fontSize: "16px", color: "#25282B" }}>
                        {code}
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
              <Button
                onClick={onCopyClinicCode}
                startIcon={<CopyIcon />}
                style={{
                  width: '20%',
                  marginTop: "10px",
                  backgroundColor: "#FFFFFF",
                  color: "#8193A6",
                  border: "2px solid #F1F2F4",
                  borderRadius: "6px",
                  fontSize: "12px",
                  textTransform: "none"
                }}>
                Copy
              </Button>
            </Grid>
          </DialogContent >
          <DialogActions style={{ paddingRight: "20px", paddingBottom: "20px" }}>
            <Button
              style={{ textTransform: "none" }}
              color="customGray"
              onClick={props.handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => props.handleClose()}
              style={SubmitButton}
            >
              Done
            </Button>
          </DialogActions>
        </>
      )
    } else {
      return (
        <>
          <DialogContent>
            <DialogContentText
              variant="subtitle2"
              style={{ color: "rgba(36, 39, 49, 1)", paddingBottom: "5px" }}
            >
              Clinic Name
            </DialogContentText>
            <TextInput
              error={props.nameError.status}
              value={props.name}
              onChange={(e) => props.readClinic(e.target.value)}
              placeholder="Enter Clinic Name"
              fullWidth
              style={{ paddingBottom: "10px" }}
            />
            <Typography style={helperText}>{props.nameError.msg}</Typography>
            <DialogContentText
              variant="subtitle2"
              style={{ color: "rgba(36, 39, 49, 1)", paddingBottom: "5px" }}
            >
              Location
            </DialogContentText>
            <TextInput
              error={props.locationError.status}
              value={props.location}
              onChange={(e) => props.readLocation(e.target.value)}
              placeholder="Enter Location"
              fullWidth
              style={{ paddingBottom: "10px" }}
            />
            <Typography style={helperText}>{props.locationError.msg}</Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",   // vertically center
                width: "100%",
              }}
            >
              <CustomDivider width="47%" mr="5px"/> <Typography>Or</Typography> <CustomDivider ml="5px" width="47%"/> 
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <TextInput
                error={false}
                value={props.coordinates}
                onChange={(e) => props.readCoordinates(e.target.value)}
                placeholder="Enter GPS Coordinates"
                sx={{ width: "65%", flexBasis: "65%" }}
                style={{ paddingBottom: "10px", paddingTop: "10px" }}
              />

              <Tooltip
                placement="top"
                PopperProps={{
                  sx: {
                    "& .MuiTooltip-tooltip": {
                      backgroundColor: "transparent", 
                      boxShadow: "none",              
                      padding: 0,                     
                      margin: 0,  
                      borderRadius:"5px",              
                    },
                  },
                }}
                title={
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src="/map.gif"   
                      alt="Help"
                      style={{ width: "80%", height: "auto", borderRadius:"5px",  }}
                    />
                  </Box>
                }
              >

              <svg
                width="24"
                height="25"
                style={{ marginLeft: "20px",   cursor:"pointer" }}
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z"
                  stroke="#25282B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 8.5V12.5"
                  stroke="#25282B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 16.5H12.01"
                  stroke="#25282B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              </Tooltip>

               <Button
                  variant="contained"
                  onClick={() => props.viewMap()}
                  style={ViewMapButton}
                  disabled={!isValidCoordinates(props.coordinates)}
                >
                  Enter
                </Button>
            </Box>
            <Typography style={helperText}>{props.coordinatesError.msg}</Typography>
            {
              (props.map ===true) && 
               <iframe
              title="map"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              src={`https://www.google.com/maps?q=${props.coordinates.split(",")[0]},${props.coordinates.split(",")[1]}&z=${15}&output=embed`}
              allowFullScreen
            />
            }
            
            <DialogContentText
              variant="subtitle2"
              style={{ color: "rgba(36, 39, 49, 1)", paddingBottom: "5px" }}
            >
              Contact No
            </DialogContentText>
           <Box sx={{ display: "flex", alignItems: "center", gap: 2, paddingBottom: "10px"}}>
            <PhoneInput
              onChange={(e) => props.readCode(e)}
              country="us"
              disableDropdown={false}
              disableCountryCode={true}
              countryCodeEditable={false}
              value={props.code}
              placeholder=""
              inputStyle={{
                width: "90px",
                height: 38,
                backgroundColor: "#fff", 
                boxShadow: "none",
              }}
              buttonStyle={{
                backgroundColor: "#fff", 
                borderRight: "none",           
                boxShadow: "none",
              }}
              containerStyle={{
                height: 38,
                width: "20%",
                border: "none",
                boxShadow: "none",
                display: "flex",
              }}
              dropdownStyle={{ zIndex: 1300 }}
            />

            <TextInput
              type="text"
              onKeyDown={(e) => e.key === "e" && e.preventDefault()}
              error={props.contactError.status}
              value={props.contact}
              onChange={(e) => props.readContact(e.target.value, e)}
              fullWidth
              placeholder="Enter Contact no"
            />
          </Box>
            <Typography style={helperText}>{props.contactError.msg}</Typography>
            <DialogContentText
              variant="subtitle2"
              style={{ color: "rgba(36, 39, 49, 1)", paddingBottom: "5px" }}
            >
              Email
            </DialogContentText>
            <TextInput
              error={props.emailError.status}
              value={props.email}
              onChange={(e) => props.readEmail(e.target.value)}
              placeholder="Enter Email"
              fullWidth
              style={{ paddingBottom: "10px" }}
            />
            <Typography style={helperText}>{props.emailError.msg}</Typography>
            <DialogContentText
              variant="subtitle2"
              style={{ color: "rgba(36, 39, 49, 1)", paddingBottom: "5px" }}
            >
              Choose reporting record types for the patient app
            </DialogContentText>

            {props.clinicTypes.map((t, i) => {
              return (
                <div key={i}>
                  <Checkbox
                    icon={
                      props.selectedClinicTypes.includes(t.code) ? (
                        <CheckBoxIcon />
                      ) : (
                        <CheckboxBorder />
                      )
                    }
                    style={{ paddingLeft: "0px" }}
                    size="small"
                    onChange={() => props.readClinicType(t.code)}
                    checked={
                      props.selectedClinicTypes.includes(t.code) ? true : false
                    }
                  />
                  <Typography
                    variant="subtitle2"
                    style={{
                      display: "inline",
                      color: "#676767",
                    }}
                  >
                    {t.name}
                  </Typography>
                  <br />
                </div>
              );
            })}
            <Typography style={helperText}>
              {props.clinicTypeError.msg}
            </Typography>
            <Grid container>
              <Grid item xs={7} md={7}>
                <DialogContentText
                  variant="subtitle2"
                  style={{ color: "rgba(36, 39, 49, 1)", paddingBottom: "5px" }}
                >
                  Enable Chat Functionality in mobile apps
                </DialogContentText>
              </Grid>
              <Grid item xs={5} md={5}>
                <SwitchButton
                  disableChat={props.disableChat}
                  readChatDisable={() => props.readChatDisable()}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ paddingRight: "20px", paddingBottom: "20px" }}>
            <Button
              style={{ textTransform: "none" }}
              color="customGray"
              onClick={props.handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => props.addNewClinic()}
              style={SubmitButton}
              disabled={props.addClinicLoading}
            >
              Add Clinic
            </Button>
          </DialogActions>
        </>);
    }
  }

  return (
    <div>
      <CustomizedButton onClick={props.handleClickOpen} text="New Clinic" />
      <Dialog
        maxWidth="sm"
        fullWidth={true}
        open={props.open}
        onClose={props.handleClose}
        style={DialogBackground}
      >
        <DialogTitle style={DialogTitleStyle} id="alert-dialog-title">
          {props.title}
          <IconButton onClick={props.handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {renderDialogContent()}
      </Dialog>
    </div>
  );
}
